module.exports = __webpack_public_path__ + "static/media/a-73.0ee6dd51.svg";